<script>
  import { router } from '@inertiajs/svelte'
  import ApplicationLayout from '@/components/ApplicationLayout/index.svelte'
  
  let { sessions = [], notice = '', user = {} } = $props();

  function logoutSession(id) {
    router.delete(`/sessions/${id}`, {
      onSuccess: () => {
        // The page will automatically refresh with updated data
      }
    });
  }

  function formatDate(dateString) {
    return new Date(dateString).toLocaleString();
  }

  function getBrowserInfo(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('chrome')) return 'Chrome';
    if (ua.includes('firefox')) return 'Firefox';
    if (ua.includes('safari')) return 'Safari';
    if (ua.includes('edge')) return 'Edge';
    return 'Unknown Browser';
  }

  function getDeviceType(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('mobile')) return 'Mobile';
    if (ua.includes('tablet')) return 'Tablet';
    return 'Desktop';
  }
</script>

<ApplicationLayout {user}>
  <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
    {#if notice}
      <div class="mb-4 p-4 text-sm text-green-700 bg-green-100 rounded-lg" role="alert">
        {notice}
      </div>
    {/if}

    <div class="px-4 py-6 sm:px-0">
      <div class="mb-8">
        <h1 class="text-2xl font-semibold text-gray-900">Devices & Sessions</h1>
        <p class="mt-1 text-sm text-gray-600">
          Manage your active sessions and devices.
        </p>
      </div>

      <div class="bg-white shadow overflow-hidden sm:rounded-md">
        <ul role="list" class="divide-y divide-gray-200">
          {#each sessions as session}
            <li>
              <div class="px-4 py-4 sm:px-6">
                <div class="flex items-center justify-between">
                  <div class="flex items-center">
                    <div class="flex-shrink-0">
                      {#if getDeviceType(session.user_agent) === 'Mobile'}
                        <svg class="h-6 w-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                        </svg>
                      {:else if getDeviceType(session.user_agent) === 'Tablet'}
                        <svg class="h-6 w-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                        </svg>
                      {:else}
                        <svg class="h-6 w-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                      {/if}
                    </div>
                    <div class="ml-4">
                      <div class="text-sm font-medium text-gray-900">
                        {getBrowserInfo(session.user_agent)} on {getDeviceType(session.user_agent)}
                      </div>
                      <div class="text-sm text-gray-500">
                        {session.ip_address}
                      </div>
                    </div>
                  </div>
                  <div class="ml-2 flex-shrink-0 flex">
                    <button
                      onclick={() => logoutSession(session.id)}
                      class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                    >
                      Sign out
                    </button>
                  </div>
                </div>
                <div class="mt-2 sm:flex sm:justify-between">
                  <div class="sm:flex">
                    <div class="flex items-center text-sm text-gray-500">
                      <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      Last active {formatDate(session.created_at)}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          {/each}
        </ul>
      </div>
    </div>
  </div>
</ApplicationLayout>

<style>
  button {
    padding: 0.5rem 1rem;
    cursor: pointer;
    background-color: #f44336;
    color: white;
    border: none;
    border-radius: 4px;
  }
  
  button:hover {
    background-color: #d32f2f;
  }
</style>